// src/components/stats/StatFocusChips.jsx -- presentational stat-focus chip row.
// Chips are derived by StatsPage from the player's role(s) via the STAT_DEFINITIONS
// registry; this component only renders them and reports selection. Spec §C4.

export default function StatFocusChips({ chips, focusStatId, onSelect }) {
  if (!chips || chips.length === 0) return null;
  return (
    <div style={{ display: 'flex', gap: 8, overflowX: 'auto', padding: '8px 0', WebkitOverflowScrolling: 'touch' }}>
      {chips.map((c) => {
        const active = c.id === focusStatId;
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onSelect(c.id)}
            aria-pressed={active}
            style={{
              flexShrink: 0, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 800, fontSize: 12,
              borderRadius: 999, padding: '8px 14px', whiteSpace: 'nowrap',
              background: active ? 'linear-gradient(135deg,#1d4ed8,#4f46e5)' : '#0b1626',
              color: active ? '#fff' : '#cbd5e1',
              border: active ? '1px solid transparent' : '1px solid #1e293b',
            }}
          >
            {c.shortLabel}
          </button>
        );
      })}
    </div>
  );
}
